import { render } from "./alert_sf.vue?vue&type=template&id=0d9cff42"
import script from "./alert_sf.vue?vue&type=script&lang=js"
export * from "./alert_sf.vue?vue&type=script&lang=js"

import exportComponent from "/var/deploy/beta/web_head/releases/20260320221641/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__